/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { DropdownButton, FilledButton, Menu, Popover } from '@neo4j-ndl/react';
import { useRef, useState } from 'react';

const Component = () => {
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <>
      <Menu
        isOpen={isOpen}
        anchorRef={anchorEl}
        onClose={(_event, _data) => {
          setIsOpen(false);
        }}
        htmlAttributes={{ id: 'popover-menu' }}
      >
        <Menu.Item title="Action 1" onClick={() => alert('Action1')} />
        <Menu.Item title="Action 2" onClick={() => alert('Action2')} />
        <Menu.Item
          title="Action 3"
          description="Action 3 is disabled"
          isDisabled={true}
          onClick={() => alert('Action3')}
        />
        <Menu.Item
          title="Action 4"
          description="Action 4 is awesome"
          onClick={() => alert('Action4')}
        />
      </Menu>

      <Popover isOpen={isPopoverOpen}>
        <Popover.Trigger>
          <FilledButton onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
            {isPopoverOpen ? 'Close' : 'Open'} Popover
          </FilledButton>
        </Popover.Trigger>
        <Popover.Content style={{ height: 150, overflow: 'auto', width: 400 }}>
          <>
            <p>
              Scroll me to the bottom to open menu Lorem ipsum dolor sit amet,
              consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Ut enim ad minim veniam, quis
              nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in voluptate
              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
              occaecat cupidatat non proident, sunt in culpa qui officia
              deserunt mollit anim id est laborum.
            </p>
            <DropdownButton
              isOpen={isOpen}
              onClick={() => setIsOpen(true)}
              ref={anchorEl}
              aria-haspopup="menu"
            >
              Open Context Menu
            </DropdownButton>
          </>
        </Popover.Content>
      </Popover>
    </>
  );
};

export default Component;
